// types
import { Account } from '../../../@types';

// mui
import { Typography } from '@mui/material';

// props
export interface ListItemTextAccountProps {
	account: Account;
}

export const ListItemTextAccount = ({ account }: ListItemTextAccountProps) => {
	return (
		<Typography component="span">
			{account.name}
			{account.currency && (
				<>
					<Typography color="common.black" component="span" fontWeight={600}>
						{' '}
						{account.currency}
					</Typography>
				</>
			)}
		</Typography>
	);
};
